// Detect if user is on a mobile device
export const isMobile = (): boolean => {
  if (typeof globalThis.navigator === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    globalThis.navigator.userAgent
  );
};

// Detect if user is on iOS
export const isIOS = (): boolean => {
  if (typeof globalThis.navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(globalThis.navigator.userAgent);
};

// Detect if user is on Safari (including Safari on iOS)
export const isSafari = (): boolean => {
  if (typeof globalThis.navigator === 'undefined') return false;
  const ua = globalThis.navigator.userAgent;
  // Safari detection: Safari has Safari in UA but not Chrome/Edge/Firefox
  return /Safari/i.test(ua) && !/Chrome|CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
};
